import { render, staticRenderFns } from "./HiboMultiSelect.vue?vue&type=template&id=28febb8c&"
import script from "./HiboMultiSelect.vue?vue&type=script&lang=ts&"
export * from "./HiboMultiSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports